import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    background: theme.palette.common.white,
    padding: 24,
    borderRadius: 8,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    [theme.breakpoints.down('sm')]: {
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px -1px rgba(19, 45, 74, 0.04)',
      borderRadius: '0px !important',
    },
  },
  containerSidebar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0px !important',
    },
  },
  sidebarInformation: {
    alignItems: 'center',
  },
  darkBlue: {
    color: theme.palette.primary.dark,
  },
  address: {
    textAlign: 'right',
  },
  city: {
    color: theme.palette.secondary.dark,
  },
  link: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  containerAssetInfo: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  assetInfo: {
    display: 'flex',
  },
  iconGrey: {
    color: theme.palette.secondary.main,
    marginRight: 12,
  },
  iconGreyBedroom: {
    color: theme.palette.secondary.main,
    marginRight: 7,
  },
  assetInfoPadding: {
    paddingTop: 8,
  },
  cancel: {
    width: '100%',
    marginTop: 24,
    margin: 'auto',
  },
  instructionMobile: {
    padding: '0 16px',
    marginTop: 24,
  },
}))
